import { Component, Inject, OnInit } from '@angular/core';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';

@Component({
  selector: 'password-modal',
  templateUrl: './password-modal.html',
  styleUrls: ['./password-modal.scss']
})
export class PasswordModalComponent {
  password: string = '';
  showPassword: boolean = false;

  constructor(
    public modalComponentRef: BzgModalRef, 
    private _cryptoDataService: CryptoDataService,
    @Inject(BZG_MODAL_DATA) public data: { password: string }) {
      this.password = data.password;
    }

  close() {
    this.modalComponentRef.close();
  }

  ok() {
    this.modalComponentRef.close(this.password);
  }

  encryptPassword() {
    if (this.password && (this.password.length > 0) && this.password !== '****') {
      this._cryptoDataService.encryptString(this.password).subscribe(result => {
        this.password = result.encryptedPassword;
      });
    }
  }
  
  maxLengthPassword() {
    return this.password.startsWith('CRYPT.4.BIZAGI:') ? 500 : 256;
  }

  showEncrypt() {
    this.showPassword = !this.showPassword;
  }
}
